import React, { useContext, useEffect } from "react";
import { Button } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import question_icon from "../../../../assets/images/question.png";
import axios from "axios";

const AdminDeleteALLPagamentos = (props) => {

  const styles = `

  .Maquinas-page {
    background-color: black;
    color: white; 
    margin: 0; 
    padding: 0; 
    display: flex;
    justify-content: center; 
    align-items: center; 
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;    
  }
  .Admin_Editar_container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center; 
  }
  .Admin_Editar_Icon {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
    filter: grayscale(1) invert(1);
  }
  .Admin_Editar_Text {
    color: yellow; 
    font-size: 20px;
    margin-bottom: 20px;
  }
  .Admin_Editar_Btns {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
  .Admin_Botao-Cancelar,
  .Admin_Editar_Delete_Btn {
    display: flex;
    justify-content: center; 
    align-items: center; 
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 18px;
    border: none;
    transition: all 0.3s ease;
    width: auto; /* Faz os botões ocuparem o espaço necessário para o texto */
  }
  .Admin_Botao-Cancelar {
    background-color: red; 
    color: white;
  }
  .Admin_Botao-Cancelar:hover {
    background-color: darkred;
  }
  .Admin_Editar_Delete_Btn {
    background-color: green; 
    color: white;
  }
  .Admin_Editar_Delete_Btn:hover {
    background-color: darkgreen;
  }
    `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);


  const location = useLocation();
  let navigate = useNavigate();

  const { maquinaInfos } = location.state;

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const deleteHandler = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_SERVIDOR}/delete-pagamentos-adm/${maquinaInfos.id}`,
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: { id },
    };

    axios
      .request(config)
      .then((res) => {
        setNotiMessage({
          type: "success",
          message: "Deleted Successfully.",
        });
        navigate(`/cliente-maquinas/pagamentos/${id}`, {
          state: location.state,
        });
      })
      .catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message: "Delete Failed",
          });
          setDataUser(null);
        }
      });
  };

  return (
    <div className="Maquinas-page">
    <div className="Admin_Editar_container">
      <div className="Admin_Editar_Content">
        <img
          className="Admin_Editar_Icon"
          src={question_icon}
          alt="question icon"
        />
        <p className="Admin_Editar_Text">
          Deseja limpar os dados da máquina neste período?
        </p>
        <div className="Admin_Editar_Btns">
          <Button
            className="Admin_Botao-Cancelar"
            onClick={() => {
              navigate(`/cliente-maquinas/pagamentos/${id}`, {
                state: location.state,
              });
            }}
          >
            <span>NÃO</span>
          </Button>{" "}
          <Button
            className="Admin_Editar_Delete_Btn"
            onClick={() => {
              deleteHandler();
            }}
          >
            <span>SIM, EXCLUA</span>
          </Button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default AdminDeleteALLPagamentos;
